import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faUpload } from "@fortawesome/free-solid-svg-icons";

const PdfUpload = ({ file, onFileChange, label }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/pdf": [] },
    multiple: true,
    onDrop: (files) => {
      onFileChange(files); // full array
    }
  });

  useEffect(() => {
    if (!file) {
      // Reset handled by parent
    }
  }, [file]);

  return (
    <div className="mb-3">
      <Form.Label>{label}</Form.Label>
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? "dropzone-active" : ""}`}
        style={{
          border: "2px dashed #4f46e5",
          padding: "40px",
          textAlign: "center",
          cursor: "pointer",
          borderRadius: "12px",
          backgroundColor: isDragActive ? "#f0f4ff" : "#fafafa",
          transition: "all 0.2s ease-in-out",
          position: "relative"
        }}
      >
        <input {...getInputProps()} />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <FontAwesomeIcon icon={faUpload} size="2x" color="#4f46e5" style={{ marginBottom: "10px" }} />
          {isDragActive ? (
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#4f46e5" }}>
              Drop the PDF here...
            </p>
          ) : (
            <p style={{ fontSize: "14px", color: "#6b7280" }}>
              Drag & drop a PDF here, or click to select
            </p>
          )}
        </div>
        {Array.isArray(file) && file.length > 0 && (
          file.map((f, i) => (
            <div key={i} style={{
              marginTop: "15px",
              padding: "10px 15px",
              borderRadius: "8px",
              backgroundColor: "#fff",
              border: "1px solid #4f46e5",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
            }}>
              <span>{f.name}</span>
              <span onClick={() => onFileChange(file.filter((x, idx) => idx !== i))}>✕</span>
            </div>
          ))
        )}

        {/* {file && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px 15px",
              borderRadius: "8px",
              backgroundColor: "#fff",
              border: "1px solid #4f46e5",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FontAwesomeIcon icon={faFilePdf} size="lg" color="#e11d48" style={{ marginRight: "10px" }} />
              <span style={{ fontWeight: "500" }}>{file.name}</span>
            </div>
            <span
              style={{ cursor: "pointer", color: "#6b7280", fontWeight: "bold" }}
              onClick={() => onFileChange(null)}
            >
              ✕
            </span>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default PdfUpload;
